import React, { Component } from "react";
import { findDOMNode } from 'react-dom';
import _ from "lodash";
import classNames from "classnames";
import { connect } from "react-redux";
import { SizeMe } from "react-sizeme";
import {
    updateShadowCard,
    updateGroupList,
    updateCurrEditID,
    setDraggingItems,
    setSaveComplete,
    setUpdateLayout,
    setDragOverGroup,
} from "Store/GridLayout/action";
//自定义组件
import {
    getNewGroupItemNum,
    getUniqueItems,
    getRepeatItems,
    GRID_COLS,
    checkApp,
    DragTypes,
    calcDraggingItemsPos,
} from "./utilService";
import GroupItemHeader from "./groupItemHeader";
import GroupItem from "./groupItem";
import GroupItemDragLayer from "./GroupItemDragLayer";
import MyContentAnchor from "./anchor";
import MyFooter from "./footer";
import Notice from "Components/Notice";
import { scroller, Element } from "react-scroll";
import platform from "Pub/js/platform";
import Home from "./Home";
import GridLayout from "./GridLayout";
import "./index.less";
import { getBackgroundStyle } from "Pub/js/backgroundImg";
import Ajax from "Pub/js/ajax";
const { NCDiv } = platform.base;
const { PubSub } = platform;

//内容组件类
class MyContent extends Component {
    deleteApps = []; // 记录删除的
    state = {
        bgStyle: {},
        gridLayoutDroppable: true, //GridLayout是否可拖放
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.editable == true && this.props.editable !== nextProps.editable) {
            this.props.setSaveComplete(false); //重置保存标识
            if (nextProps.groups.length) {
                //编辑态滚动到顶部
                setTimeout(() => {
                    scroller.scrollTo(nextProps.groups[0].pk_app_group, {
                        offset: -40,
                        containerId: "ncWorkbenchHomeEditPage",
                    });
                });
            }
        }
        //切换背景设置
        if (!_.eq(nextProps.backgroundState, this.props.backgroundState) || (nextProps.themeColor !== this.props.themeColor)) {
            this.setBackgroundStyle(nextProps.backgroundState, nextProps.themeColor);
        }
    }
    /**
     * 释放sider区中选中的所有卡片CardList到分组中
     * @param {Object} dragItem 拖拽sider区中选中的所有卡片
     * @param {Object} dropItem 释放的目标组对象
     **/
    onCardListDropInGroupItem = (dragItem, dropItem) => {
        this.props.setDraggingItems({
            from: DragTypes.SIDE_CARD,
            data: dragItem.cardList,
        });
        PubSub.publish('AutomaticTowing', dropItem.index);
    };

    //向分组中添加item
    addItem2Group = (dragItem, groupId) => {
        let groups = _.cloneDeep(this.props.groups);
        const groupIndex = groups.findIndex(item => item.pk_app_group === groupId);
        if (dragItem && groupIndex !== -1) {
            groups[groupIndex].apps = groups[groupIndex].apps.concat(dragItem);
            this.props.updateGroupList(groups);
        }
    };
    /**
     * 向上移动组
     * @param {Number} groupIndex 目标分组index
     **/
    upGroupItem = groupIndex => {
        let { groups } = this.props;
        groups = _.cloneDeep(groups);
        //已第一个组，直接return
        if (groupIndex === 0) {
            return;
        }
        const preGroup = groups[groupIndex - 1];
        groups[groupIndex - 1] = groups[groupIndex];
        groups[groupIndex] = preGroup;
        this.props.updateGroupList(groups);
    };
    /**
     * 向下移动组
     * @param {Number} groupIndex 目标分组index
     **/
    downGroupItem = groupIndex => {
        let { groups } = this.props;
        groups = _.cloneDeep(groups);
        //已最后一个组，直接return
        if (groupIndex === groups.length - 1) {
            return;
        }
        const nextGroup = groups[groupIndex + 1];
        groups[groupIndex + 1] = groups[groupIndex];
        groups[groupIndex] = nextGroup;
        this.props.updateGroupList(groups);
    };
    /**
     * 删除分组
     * @param {String} groupID 目标分组id
     **/
    deleteGroupItem = groupID => {
        let { groups } = this.props;
        groups = _.cloneDeep(groups);

        _.remove(groups, g => {
            return g.pk_app_group === groupID;
        });
        this.props.updateGroupList(groups);
        this.props.onCheckDeduplication(groups);
    };
    /**
     * 添加第一个组
     **/
    addFirstGroupItem = () => {
        let { groups, getEmptyGroupInfo } = this.props;
        groups = _.cloneDeep(groups);
        const tmpItem = getEmptyGroupInfo();
        groups.push(tmpItem);
        this.props.updateCurrEditID(tmpItem.pk_app_group);
        this.props.updateGroupList(groups);
    };
    /**
     * 添加组
     * @param {Number} groupIndex 目标分组index
     **/
    addGroupItem = groupIndex => {
        let { groups } = this.props;
        let groupNameNation = this.props.json["DesktopSetting-000002"];
        groups = _.cloneDeep(groups);
        let insertIndex = groupIndex;
        const tmpItem = {
            pk_app_group: "newGroupItem" + new Date().getTime(),
            groupname: `${this.props.json["DesktopSetting-000002"]}(${getNewGroupItemNum(
                groupNameNation,
                groups,
            )})` /* 国际化处理： 分组*/,
            type: "group",
            apps: [],
        };
        groups.splice(insertIndex + 1, 0, tmpItem);
        //更新分组的redux之后，scroll滚动
        this.asyncUpdateGroupList(groups).then(() => {
            setTimeout(() => {
                scroller.scrollTo(`${tmpItem.pk_app_group}`, {
                    offset: groupIndex != -1 ? -20 : -15,
                    spy: true,
                    smooth: true,
                    duration: 250,
                    containerId: "ncWorkbenchHomeEditPage",
                });
            }, 300);
        });
        this.props.updateCurrEditID(tmpItem.pk_app_group);
    };
    async asyncUpdateGroupList(groups) {
        let user = await this.props.updateGroupList(groups);
        return user;
    }
    /**
     * 移动组的顺序
     * @param {Number} dragIndex 拖拽的组对象的index值
     * @param {Number} hoverIndex 拖拽中鼠标悬浮的组对象的index值
     **/
    moveGroupItem = (dragIndex, hoverIndex) => {
        let { groups } = this.props;
        groups = _.cloneDeep(groups);
        const dragCard = groups[dragIndex];
        groups.splice(dragIndex, 1);
        groups.splice(hoverIndex, 0, dragCard);
        this.props.updateGroupList(groups);
    };

    /**
     * 修改分组名称
     * @param {Number} groupIndex 目标分组index
     * @param {String} groupname 分组名称
     **/
    changeGroupName = (groupIndex, groupname) => {
        let { groups } = this.props;
        groups = _.cloneDeep(groups);
        groups[groupIndex].groupname = groupname;
        this.props.updateGroupList(groups);
        this.props.updateCurrEditID("");
    };

    componentDidMount() {
        //初始化时默认执行新增分组的方法
        this.initFirstGroup(this.props);
        const { backgroundState, themeColor } = this.props;
        this.setBackgroundStyle(backgroundState, themeColor);
        //监听设置GridLayout Droppable事件
        //拖拽groupItem时禁用Droppable事件
        this.pubsubDrop = PubSub.subscribe("setGridDroppable", (action, data) => {
            this.setState({ gridLayoutDroppable: data });
        });
        this.desktopSavePubsub = PubSub.subscribe('SetAppComplete', () => {
            if (!this.deleteApps.length) {return;}

            this.handleDeleteApps();
        });
    }

    componentWillUnmount() {
        //移除订阅
        PubSub.unsubscribe(this.pubsubDrop);
        PubSub.unsubscribe(this.desktopSavePubsub);
    }
    //初始化时默认执行新增分组的方法
    initFirstGroup = props => {
        setTimeout(() => {
            if (props.editable && props.groups.length === 0) {
                this.addFirstGroupItem();
            }
        });
    };
    /**
     * 监听GridLayout drop事件
     *
     */
    handleLayoutDrop = (group, groupIndex) => {
        //layout:布局数据 isGridDrop：区分是不是拖拽到GridLayout
        return (layout, isGridDrop) => {
            let { draggingItems } = this.props;
            const isAdd = draggingItems.from === DragTypes.SIDE_CARD; //从左侧拖出来表示新增
            //拖拽card才校验重复
            if (isGridDrop && this.props.isDroppable) {
                draggingItems.data = this.validateRepeatCards(group);
                this.props.setDraggingItems(draggingItems);
                PubSub.publish("onGridLayoutDropEnd", { layout, draggingItems });
            }
            //清空dragOver状态
            if (this.props.dragOverGroupItem) {
                this.props.setDragOverGroup(null);
            }
            return [draggingItems.data, isAdd];
        };
    };

    //元素拖到分组上面
    handleGroupDragOver = (dragOverGroup = null) => {
        if (this.props.dragOverGroupItem !== dragOverGroup) {
            this.props.setDragOverGroup(dragOverGroup);
        }
    }

    //校验是否有重复卡片
    validateRepeatCards = group => {
        const { draggingItems, json } = this.props;
        const repeatCards = getRepeatItems(group.apps, draggingItems.data, "appcode"); // 重复的数据
        const newRepeatCards = _.remove(repeatCards, item => {
            return !item.isNotRepeat && !checkApp(item).isExternalLink; // 去掉不校验重复的cards
        });
        //已添加card不再重复添加
        if (newRepeatCards.length) {
            const uniqueCards = getUniqueItems(group.apps, draggingItems.data, "appcode"); // 去重后cards
            const repeatCardsName = newRepeatCards.map(r => r.name);
            Notice({
                status: "warning",
                msg: `${json["DesktopSetting-000089"]}${json["DesktopSetting-000057"]}${repeatCardsName.join(
                    ",",
                )},${json["DesktopSetting-000058"]}`, // 工作台内已有应用采购订单、XXX，此次不再重复添加
            });
            return [...repeatCards, ...uniqueCards]; // 可以重复的cards + 去重后的cards
        }
        return draggingItems.data;
    };
    //获取重复cards
    getRepeatCards = (group, cards) => {
        let result = [];
        group.forEach(item => {
            cards.forEach(card => {
                if (item.appcode === card.appcode) {
                    result.push(card);
                }
            });
        });
        return result;
    };

    //渲染新增分组按钮
    renderAddBtn = index => {
        if (!this.props.editable) {return null;}
        return (
            <div
                key={index}
                className={classNames("group-item-add", { first: index === -1 })}
                onClick={() => this.addGroupItem(index)}
            >
                +
            </div>
        );
    };

    //设置背景样式
    setBackgroundStyle = (bgObj = {}, themeColor = '') => {
        const bgStyle = getBackgroundStyle(bgObj, themeColor);
        this.setState({ bgStyle });
    };

    //分组样式
    getGroupItemStyle = isLast => {
        let style = {};
        const $groupContainer = document.querySelector("#ncWorkbenchHomePage");
        const $lastGroupContainer = $groupContainer && $groupContainer.querySelector(".group-item-scroll-wrap.last-item");
        //计算最后一个分组的marginBottom，为了使分组导航能定位到最后一个分组
        if (isLast && $groupContainer && $lastGroupContainer && !this.props.editable) {
            const containerHeight = window.innerHeight - $groupContainer.getBoundingClientRect().top;
            const lastItemHeight = $lastGroupContainer.clientHeight;
            style.marginBottom = containerHeight - Math.min(lastItemHeight, containerHeight) + 1; //父容器高度-分组高度 +1防止个别电脑滚动不到最后一个分组
        }
        return style;
    }

    // 删除事件处理
    handleDeleteItem = app => {
        if (!app.isNew) { // 记录非新拖放的
            this.deleteApps.push(app);
        }
    }

    // 一键清空
    handleClearAll = (immediately = false) => {
        const { groups } = this.props;
        groups.forEach(group => {
            group.apps.forEach(app => {
                this.handleDeleteItem(app);
            });
        });
        immediately && this.handleDeleteApps();
    }

    // 删除
    handleDeleteApps = () => {
        const { relateidObj, groupId, userId, workbenchid } = this.props;
        const commonParams = {
            workbenchid,
            isuser: relateidObj.code,
        };
        if (relateidObj.code == 1) {
            commonParams.relationid = userId; // 用户id，用户桌面配置传，工作台管理过来的不传
        }
        if (relateidObj.type == 'workbench') { // 工作台过来的
            commonParams.workbenchid = relateidObj.data;
        }
        const quickLaunchParams = [];
        this.deleteApps.forEach(item => {
            const checkObj = checkApp(item);
            if (checkObj.isQuickLaunch) {
                quickLaunchParams.push({ ...commonParams, pk_group_app: item.cardid });
            }
        });

        // 快速发起的
        if (quickLaunchParams.length) {
            Ajax({
                data: quickLaunchParams,
                url: `/nccloud/platform/appregister/delquicklaunch.do`,
                loading: true,
                success: () => {
                },
            });
        }
    }

    renderGroups = () => {
        let { groups, editable, dragOverGroupItem, relateidObj, gridContainerPadding, themeColor } = this.props;
        const SortableGroupItem = ({ group, index, groupArr, size }) => {
            const getActiveCls = () => {
                return editable && dragOverGroupItem && group.pk_app_group === dragOverGroupItem.pk_app_group;
            };
            const isLastOne = index === groupArr.length - 1; //是否最后一个分组
            const groupHeader = (
                <GroupItemHeader
                    key={group.pk_app_group}
                    id={group.pk_app_group}
                    cards={group.apps}
                    groupname={group.groupname}
                    index={index}
                    length={groupArr.length}
                    changeGroupName={this.changeGroupName}
                    deleteGroupItem={this.deleteGroupItem}
                    downGroupItem={this.downGroupItem}
                    upGroupItem={this.upGroupItem}
                    onCardsMove={this.onCardListDropInGroupItem}
                    siderComponent={this.props.siderComponent}
                />
            );
            const groupContent = (
                <GridLayout
                    key={group.pk_app_group + editable} //切换编辑态重新挂载GridLayout
                    apps={group.apps}
                    groupId={group.pk_app_group}
                    groupItem={group}
                    groupIndex={index}
                    margin={this.props.margin}
                    col={GRID_COLS}
                    gridContainerPadding={gridContainerPadding}
                    size={size}
                    isDroppable={this.state.gridLayoutDroppable}
                    onDrop={this.handleLayoutDrop(group, index)}
                    onAddGroupItem={this.addItem2Group}
                    onGridDragOver={this.handleGroupDragOver}
                    relateidObj={relateidObj}
                    onDeleteItem={this.handleDeleteItem}
                    themeColor={themeColor}
                />
            );
            return (
                <Element
                    name={group.pk_app_group}
                    className={classNames("group-item-scroll-wrap", {
                        editable,
                        "active": getActiveCls(),
                        'last-item': isLastOne,
                    })}
                    style={groupArr.length > 1 ? this.getGroupItemStyle(isLastOne) : {}}
                    onMouseEnter={() => this.handleGroupDragOver(group)}
                >
                    <GroupItem
                        key={group.pk_app_group}
                        id={group.pk_app_group}
                        header={groupHeader}
                        content={groupContent}
                        group={group}
                        index={index}
                        moveGroupItem={this.moveGroupItem}
                    />
                    {/* {this.renderAddBtn(index)} */}
                </Element>
            );
        };
        return (
            <SizeMe
                refreshMode='debounce'
                refreshRate={100}
            >
                {({ size }) => (
                    <div className="nc-workbench-home-content" onMouseLeave={() => this.handleGroupDragOver(null)}>
                        {/* {this.renderAddBtn(-1)} */}
                        {groups.map((group, index, groupArr) =>
                            SortableGroupItem({ group, index, groupArr, size }), //不这么写拖拽GridItem时GridLayout会重新render
                        )}
                        <GroupItemDragLayer
                            previewCom={draggingGroupItem =>
                                <SortableGroupItem
                                    key={`${draggingGroupItem.pk_app_group}_draggingitem`}
                                    group={draggingGroupItem}
                                    index={0}
                                    groupArr={groups}
                                    size={size}
                                />
                            }
                        />
                    </div>
                )}
            </SizeMe>
        );
    };
    render() {
        const { editable, json, hasEditingSider, siderCollapsed, gridContainerPadding } = this.props;
        return (
            <NCDiv
                className={classNames("nc-desktop-setting-content", { edit: editable }, hasEditingSider ? 'desktop-has-editing-sider' : '', siderCollapsed ? '' : 'desktop-sider-expand')}
                areaCode={NCDiv.config.Area}
                fieldid="right"
            >
                <div className="workbench-background-wrapper">
                    <div className="workbench-background-content" style={this.state.bgStyle}></div>
                </div>
                {/* <MyContentAnchor onCardListDropInGroupItem={this.onCardListDropInGroupItem} /> */}
                <div
                    id="ncWorkbenchHomeEditPage"
                    className="nc-workbench-desktop-container"
                // style={editable ? { top: groups.length ? 40 : 0 } : null}
                >
                    <Home
                        onEnterEditable={isEmpty => {
                            this.props.onEnterEditable(isEmpty);
                            isEmpty && this.addFirstGroupItem();
                        }}
                        renderGroups={this.renderGroups}
                        // 这么写是为了防止进Home的didMount
                        emptyInfo={{
                            contentText: json["DesktopSetting-000062"],
                            btnText: json["DesktopSetting-000001"],
                            onBtnClick: this.addFirstGroupItem,
                        }}
                        gridContainerPadding={gridContainerPadding}
                    />
                </div>
            </NCDiv>
        );
    }
}
export default connect(
    state => ({
        groups: state.gridLayoutData.groups,
        shadowCard: state.gridLayoutData.shadowCard,
        json: state.gridLayoutData.json,
        editable: state.gridLayoutData.editable,
        draggingItems: state.gridLayoutData.draggingItems,
        margin: state.gridLayoutData.margin,
        isDroppable: state.gridLayoutData.isDroppable,
        dragOverGroupItem: state.gridLayoutData.dragOverGroupItem,
        backgroundState: state.appData.backgroundState,
        themeColor: state.appData.themeColor,
        userId: state.appData.userId,
        groupId: state.appData.groupId,
        workbenchid: state.appData.workbenchId,
        hasEditingSider: state.gridLayoutData.hasEditingSider,
        siderCollapsed: state.gridLayoutData.siderCollapsed,
    }),
    {
        updateGroupList,
        updateShadowCard,
        updateCurrEditID,
        setDraggingItems,
        setSaveComplete,
        setUpdateLayout,
        setDragOverGroup,
    },
    null,
    { forwardRef: true },
)(MyContent);
